import { useState } from 'react';
import { createEmptyLegalRepresentative } from '../components/contractGeneration/LegalRepresentativeUtils';

const useLegalRepresentativesPanel = ({
  legalRepresentatives,
  availableRepresentatives,
  addLegalRepresentative,
  removeLegalRepresentative,
}) => {
  const [expandedId, setExpandedId] = useState(null);

  const selectedRepresentatives = legalRepresentatives?.filter((lr) => lr.selected) || [];
  const availableToSelect = (availableRepresentatives || []).filter(
    (rep) => !legalRepresentatives?.some((lr) => String(lr.id) === String(rep.id)),
  );

  const handleSelectRepresentative = (event) => {
    const { value } = event.target;
    if (value === '' || value == null) return;

    if (value === 'empty') {
      const newRep = createEmptyLegalRepresentative();
      addLegalRepresentative(newRep);
      setExpandedId(newRep.id);
      return;
    }

    const newRep = availableRepresentatives?.find(
      (rep) => String(rep.id) === String(value),
    );
    if (newRep) {
      addLegalRepresentative({ ...newRep, selected: true });
      setExpandedId(newRep.id);
    }
  };

  const handleAddAnother = () => {
    const newRep = createEmptyLegalRepresentative();
    addLegalRepresentative(newRep);
    setExpandedId(newRep.id);
  };

  const handleRemove = (id) => {
    removeLegalRepresentative(id);
    if (expandedId === id) {
      setExpandedId(null);
    }
  };

  return {
    expandedId,
    setExpandedId,
    selectedRepresentatives,
    availableToSelect,
    handleSelectRepresentative,
    handleAddAnother,
    handleRemove,
  };
};

export default useLegalRepresentativesPanel;
